import type { GikIconProps } from '@gik/ui/SvgIcon/GikIcons/index';
import { GikIconDefaultSize } from '@gik/ui/SvgIcon/GikIcons/index';
import React from 'react';

export const CoverSettings = React.forwardRef(
  ({ size = GikIconDefaultSize, ...props }: GikIconProps, svgRef: React.Ref<SVGSVGElement>) => {
    return (
      <svg
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        ref={svgRef}
        {...props}
      >
        <path
          d="M18.4167 9.75008V7.58341C18.4167 7.00878 18.1884 6.45768 17.7821 6.05135C17.3757 5.64502 16.8246 5.41675 16.25 5.41675H5.41667C4.84203 5.41675 4.29093 5.64502 3.8846 6.05135C3.47827 6.45768 3.25 7.00878 3.25 7.58341V14.0834C3.25 14.6581 3.47827 15.2092 3.8846 15.6155C4.29093 16.0218 4.84203 16.2501 5.41667 16.2501H7.58333M18.4167 9.75008H20.5833C21.158 9.75008 21.7091 9.97836 22.1154 10.3847C22.5217 10.791 22.75 11.3421 22.75 11.9167V18.4167C22.75 18.9914 22.5217 19.5425 22.1154 19.9488C21.7091 20.3551 21.158 20.5834 20.5833 20.5834H9.75C9.17536 20.5834 8.62426 20.3551 8.21794 19.9488C7.81161 19.5425 7.58333 18.9914 7.58333 18.4167V11.9167C7.58333 11.3421 7.81161 10.791 8.21794 10.3847C8.62426 9.97836 9.17536 9.75008 9.75 9.75008H11.9167L12.7292 8.66675H17.3333L18.4167 9.75008ZM17.3333 15.1667C17.3333 15.7414 17.1051 16.2925 16.6987 16.6988C16.2924 17.1051 15.7413 17.3334 15.1667 17.3334C14.592 17.3334 14.0409 17.1051 13.6346 16.6988C13.2283 16.2925 13 15.7414 13 15.1667C13 14.5921 13.2283 14.041 13.6346 13.6347C14.0409 13.2284 14.592 13.0001 15.1667 13.0001C15.7413 13.0001 16.2924 13.2284 16.6987 13.6347C17.1051 14.041 17.3333 14.5921 17.3333 15.1667Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
);
